export default __webpack_public_path__ + "static/media/Toi-Black 1.aae91570.svg";